<template>
    <div class="container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item.label" :name="'_'+item.value" v-for="item in activityTypeList" :key="item.value" label-width="100px">
        </el-tab-pane>
      </el-tabs>
      <NewcomersPolite  ref="_1" v-if="activeName==='_1'"/>
      <InvitationPolite  ref="_2" v-if="activeName==='_2'"/>
      <ActivityPop  ref="_3" v-if="activeName==='_3'"/>
    </div>
  </template>
  
  <script>
  
  import {activityTypeList} from '@/constant/activityType'
  import NewcomersPolite from './NewcomersPolite.vue';
  import InvitationPolite from './InvitationPolite.vue';
  import ActivityPop from './ActivityPop.vue';

  export default {
    name: "ActiquityList",
    data() {
      return {
        activeName: '_'+activityTypeList[0].value,
      };
    },
    components: {
      NewcomersPolite,
      InvitationPolite,
      ActivityPop
    },
    created() {
    },
    computed: {
        activityTypeList() {
          return activityTypeList
        }
    },
    methods: {
      handleClick(tab) {
        if (this.$refs[tab.paneName]) {
          this.$nextTick(() => {
            this.$refs[tab.paneName].init()
          })
        }
      },
    }
  };
  </script>
  
  <style scoped>
  .handle-box {
    margin-bottom: 20px;
  }
  
  .handle-select {
    width: 120px;
  }
  
  .handle-input {
    width: 200px;
    display: inline-block;
  }
  
  .table {
    width: 100%;
    font-size: 14px;
  }
  
  .red {
    color: #ff0000;
  }
  
  .mr10 {
    margin-right: 10px;
  }
  
  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }
  
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .el-dialog__body {
    height: 50vh;
    overflow: auto;
  }
  
  /deep/.el-tabs__item {
    width: 100px;
    text-align: center;
  }
  
  .balance_detail /deep/.el-tabs__item {
    width: 250px !important;
    text-align: left;
  }
  </style>